const normalizePluginSearchText = function(value){
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
};

const filterPluginCatalog = function(pluginCatalog = [], query = ''){
  const normalizedQuery = normalizePluginSearchText(query);
  return pluginCatalog.filter((pluginItem) => {
    const haystack = normalizePluginSearchText([
      pluginItem?.name,
      pluginItem?.description,
      ...(Array.isArray(pluginItem?.keywords) ? pluginItem.keywords : []),
    ].join(' '));
    return !normalizedQuery || haystack.includes(normalizedQuery);
  });
};

export { filterPluginCatalog, normalizePluginSearchText };
